module.exports = __webpack_public_path__ + "assets/img/body_bg2 - 副本.ba23bb40.jpg";